import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ConfirmPreliminaryOrderResult,
  OrderService
} from 'src/entities/order';

export interface OrderConfirmDialogData {
  orderId: string;
  orderLabel?: string | number | null;
}

@Component({
  selector: 'app-order-confirm-dialog',
  templateUrl: './order-confirm-dialog.component.html',
  styleUrls: ['./order-freeze-deadline-dialog.component.css']
})
export class OrderConfirmDialogComponent {
  saving = false;
  error = '';

  constructor(
    private readonly orderService: OrderService,
    private readonly dialogRef: MatDialogRef<
      OrderConfirmDialogComponent,
      ConfirmPreliminaryOrderResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: OrderConfirmDialogData
  ) {}

  close(): void {
    if (this.saving) {
      return;
    }
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.saving) {
      return;
    }
    this.saving = true;
    this.error = '';
    this.orderService.confirmPreliminaryOrder(this.data.orderId).subscribe({
      next: (result) => {
        this.saving = false;
        this.dialogRef.close(result);
      },
      error: () => {
        this.saving = false;
        this.error = 'No se pudo confirmar la OS.';
      }
    });
  }
}
